import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { ClockNoBGIcon } from 'Images';

interface IUpToDate {
  eligibleFrequency: string;
}

export const UpToDate = ({ eligibleFrequency }: IUpToDate) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack direction='row' width='fit-content' alignItems='center' gap='7px'>
      <Avatar
        src={ClockNoBGIcon}
        alt={''}
        sx={{
          width: isDesktop ? '18px' : '15px',
          height: isDesktop ? '18px' : '15px',
          margin: '0 0 0 3px',
        }}
      />
      <Typography variant={'body4'}>
        {Dictionary[DICTIONARY.CompassRights].entitlements.nextDateUse}
        {eligibleFrequency}
      </Typography>
    </Stack>
  );
};
